import React from 'react';
import { Shield } from 'lucide-react';

/**
 * Compact trust signal pill — "UK Data Hosted".
 * Reinforces credibility without crowding the page with corporate registration details
 * (those are present in the footer's legal disclosure block).
 */
export const TrustBadge = ({ className = 'mt-2' }) => {
  return (
    <div
      className={`flex items-center justify-center text-xs text-slate-500 ${className}`}
      data-testid="trust-badge"
    >
      <span className="inline-flex items-center gap-1" data-testid="trust-badge-uk">
        <Shield className="w-3.5 h-3.5 text-emerald-600" strokeWidth={2.25} />
        <span className="font-medium text-slate-600">UK Data Hosted</span>
      </span>
    </div>
  );
};

export default TrustBadge;
